var DOMAIN = 'http://192.168.1.83:8000';

switch(process.env.NODE_ENV){
    case "production":
        DOMAIN = 'https://auditeur4000.ddns.net:8000/audysseeapi'
        break;
    default: // development
        //DOMAIN = 'http://192.168.1.83:8000';
        DOMAIN = 'https://auditeur4000.ddns.net:8000/audysseeapi';
        break;
}

const GOOGLE_KEY = "AIzaSyAk3zwOPrW82ecvUl0SwhTP2SqY-4F9_w0"

const USER_INFO_MISSING = 'USER_INFO_MISSING';
const UPDATE_USER = 'UPDATE_USER';
const UPDATE_ISLOGGEDIN = 'UPDATE_ISLOGGEDIN';

const UPDATE_ORGANISATIONS = 'UPDATE_ORGANISATIONS';

const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';

const SHOW_CONFIRMATION = 'SHOW_CONFIRMATION';
const CLOSE_CONFIRMATION = 'CLOSE_CONFIRMATION';

const ADD_AUDIT = 'ADD_AUDIT';
const UPDATE_AUDIT = 'UPDATE_AUDIT';
const REMOVE_AUDIT = 'REMOVE_AUDIT';
const UPDATE_AUDITS = 'UPDATE_AUDITS';
const UPDATE_ARCHIVE = 'UPDATE_ARCHIVE';
const REMOVE_ARCHIVE = 'REMOVE_ARCHIVE';
const UPDATE_ARCHIVES = 'UPDATE_ARCHIVES';
const UPDATE_CALENDAR_EVENTS = 'UPDATE_CALENDAR_EVENTS';
const UPDATE_AUDITTYPES = 'UPDATE_AUDITTYPES';

const UPDATE_QUALIFICATIONS = 'UPDATE_QUALIFICATIONS';
const UPDATE_MENTIONS = 'UPDATE_MENTIONS';

const ADD_INVOICE = 'ADD_INVOICE';
const UPDATE_INVOICE = 'UPDATE_INVOICE';
const REMOVE_INVOICE = 'REMOVE_INVOICE';
const UPDATE_INVOICES = 'UPDATE_INVOICES';

const REMOVE_REPORT = 'REMOVE_REPORT';
const UPDATE_REPORT = 'UPDATE_REPORT';
const UPDATE_REPORTS = 'UPDATE_REPORTS';


const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT';
const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
const ADD_DOCUMENT_TO_REPORT = 'ADD_DOCUMENT_TO_REPORT';
const UPDATE_SURVEY_TO_REPORT = 'UPDATE_SURVEY_TO_REPORT';

const ADD_SURVEY_TO_REPORT = 'ADD_SURVEY_TO_REPORT';
const UPDATE_SURVEY = 'UPDATE_SURVEY';
const UPDATE_SURVEYS_TEMPLATES = 'UPDATE_SURVEYS_TEMPLATES';

const UPDATE_LOADING = 'UPDATE_LOADING';

export default {
    UPDATE_LOADING,
    GOOGLE_KEY,
    DOMAIN,
    UPDATE_USER,
    UPDATE_ISLOGGEDIN,
    USER_INFO_MISSING,
    UPDATE_ORGANISATIONS,
    SHOW_SNACKBAR,
    CLOSE_SNACKBAR,
    SHOW_CONFIRMATION,
    CLOSE_CONFIRMATION,
    ADD_AUDIT,
    UPDATE_AUDIT,
    REMOVE_AUDIT,
    UPDATE_AUDITS,
    UPDATE_ARCHIVE,
    REMOVE_ARCHIVE,
    UPDATE_ARCHIVES,
    UPDATE_CALENDAR_EVENTS,
    UPDATE_AUDITTYPES,
    UPDATE_QUALIFICATIONS,
    UPDATE_MENTIONS,
    ADD_INVOICE,
    UPDATE_INVOICE,
    REMOVE_INVOICE,
    UPDATE_INVOICES,
    REMOVE_REPORT,
    UPDATE_REPORT,
    UPDATE_REPORTS,
    REMOVE_DOCUMENT,
    UPDATE_DOCUMENT,
    UPDATE_SURVEY,
    ADD_DOCUMENT_TO_REPORT,
    UPDATE_SURVEYS_TEMPLATES,
    ADD_SURVEY_TO_REPORT,
    UPDATE_SURVEY_TO_REPORT,
}



// WEBPACK FOOTER //
// ./src/utils/params.js